import React from 'react';
import { Dumbbell, Trash2, Mail, Smartphone, Clock } from 'lucide-react';

const GOLD = '#EFC24E';

// Öffentliche Seite für Google Play / App Store: Konto-Löschung (Data Safety Anforderung)
export default function AccountDeletionPage() {
  return (
    <div className="min-h-screen bg-black text-white px-4 py-10">
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-11 w-11 rounded-xl flex items-center justify-center" style={{ backgroundColor: GOLD }}>
            <Dumbbell className="h-6 w-6 text-black" />
          </div>
          <div>
            <h1 className="text-2xl font-bold">StrongFit Studio</h1>
            <p className="text-xs font-semibold uppercase tracking-widest" style={{ color: GOLD }}>Konto &amp; Daten löschen</p>
          </div>
        </div>

        <div className="bg-neutral-900 border border-neutral-800 rounded-2xl p-6 sm:p-8 space-y-8" data-testid="account-deletion-card">
          <p className="text-neutral-300 text-sm leading-relaxed">
            Du kannst dein Konto in der <strong>StrongFit Studio App</strong> jederzeit löschen.
            Hier erfährst du, wie das geht und was mit deinen Daten passiert.
          </p>

          <section>
            <h2 className="flex items-center gap-2 font-semibold text-lg mb-3">
              <Smartphone className="h-5 w-5" style={{ color: GOLD }} /> Variante 1: Direkt in der App
            </h2>
            <ol className="list-decimal list-inside space-y-1.5 text-sm text-neutral-300">
              <li>Öffne die StrongFit Studio App und melde dich an</li>
              <li>Gehe zu <strong>Profil → Einstellungen</strong></li>
              <li>Tippe auf <strong>„Konto löschen"</strong></li>
              <li>Bestätige die Löschung</li>
            </ol>
          </section>

          <section>
            <h2 className="flex items-center gap-2 font-semibold text-lg mb-3">
              <Mail className="h-5 w-5" style={{ color: GOLD }} /> Variante 2: Per E-Mail beantragen
            </h2>
            <p className="text-sm text-neutral-300">
              Schreibe uns von deiner registrierten E-Mail-Adresse an{' '}
              <a href="mailto:info@strongfit.ch?subject=Konto-L%C3%B6schung%20beantragen" className="underline font-semibold" style={{ color: GOLD }}>
                info@strongfit.ch
              </a>{' '}
              mit dem Betreff <strong>„Konto-Löschung beantragen"</strong>. Wir löschen dein Konto innerhalb von 30 Tagen und bestätigen dir die Löschung.
            </p>
          </section>

          <section>
            <h2 className="flex items-center gap-2 font-semibold text-lg mb-3">
              <Trash2 className="h-5 w-5" style={{ color: GOLD }} /> Welche Daten werden gelöscht?
            </h2>
            <ul className="list-disc list-inside space-y-1.5 text-sm text-neutral-300">
              <li>Profildaten (Name, E-Mail, Telefonnummer, Profilbild)</li>
              <li>Trainings- und Terminhistorie</li>
              <li>Gesundheits- und Fitnessdaten (Body-Tracking, Messwerte)</li>
              <li>Ernährungsdaten und hochgeladene Fotos</li>
              <li>Bonuspunkte und Guthaben</li>
              <li>Push-Benachrichtigungs-Token</li>
            </ul>
          </section>

          <section>
            <h2 className="flex items-center gap-2 font-semibold text-lg mb-3">
              <Trash2 className="h-5 w-5" style={{ color: GOLD }} /> Einzelne Daten löschen (ohne Konto-Löschung)
            </h2>
            <p className="text-sm text-neutral-300">
              Du musst dein Konto nicht löschen, um einzelne Daten zu entfernen:
              Fotos, Body-Tracking-Einträge und Ernährungsdaten kannst du direkt
              in der App löschen. Für die Löschung anderer einzelner Daten schreibe uns an{' '}
              <a href="mailto:info@strongfit.ch?subject=Datenl%C3%B6schung%20beantragen" className="underline font-semibold" style={{ color: GOLD }}>
                info@strongfit.ch
              </a>{' '}
              mit dem Betreff <strong>„Datenlöschung beantragen"</strong>.
            </p>
          </section>

          <section>
            <h2 className="flex items-center gap-2 font-semibold text-lg mb-3">
              <Clock className="h-5 w-5" style={{ color: GOLD }} /> Gesetzliche Aufbewahrung
            </h2>
            <p className="text-sm text-neutral-300">
              Rechnungs- und Buchhaltungsdaten (z.&nbsp;B. bezahlte Rechnungen) müssen wir gemäss
              Schweizer Recht (Art. 958f OR) <strong>10 Jahre</strong> aufbewahren. Diese Daten werden
              nach Ablauf der Frist ebenfalls gelöscht und in der Zwischenzeit nicht mehr aktiv genutzt.
            </p>
          </section>

          <p className="text-xs text-neutral-500 border-t border-neutral-800 pt-4">
            StrongFit · Schweiz · Fragen zum Datenschutz:{' '}
            <a href="mailto:info@strongfit.ch" className="underline">info@strongfit.ch</a>
          </p>
        </div>
      </div>
    </div>
  );
}
